
import { Component, Vue } from 'vue-property-decorator'

/**
 * HeroBanner component for business-intro page
 * Only visible on PC (> 650px)
 */
@Component
export default class HeroBanner extends Vue {}
